(function($) {

	$.fn.silknav = function(options) {
	
		var settings = $.extend({
			parentEl: 'a',
			heightOffset: 1
		}, options);
		
		//So we can calculate height of largest nav element
		var navHeight = 0;
		
		function shift($el, length, offset)
		{
			//Calculate move value
			var move = ((length - offset) * 100) * -1;
				
			//Move
			$el.find('> ul').css('left', move + '%');
		}
		
		function setHeight($el, $nav)
		{
			$nav.css({
			  'height': $el.outerHeight()
			});
		}
		
		function menuaimActivate(row)
		{
			$(row).addClass('hover');
		}
		
		function menuaimDeactivate(row)
		{	
			$(row).removeClass('hover');
		}
		
		function menuaimExitMenu(menu)
		{
			return true;
		}
		
		return this.each(function() {
			
			//Shortcut to nav element
			var $nav = $(this);
			
			//Add parent class to sub menus
			$nav.find(settings.parentEl).each(function() {
			
				//Get child element
				var $child = $(this).next('ul');
			
				//If we have a child...
				if($child.length)
				{
					//Add parent class
					$(this).parent().addClass('parent');
					
					//Create next link
					$(this).append('<span class="next" />');
					
					//Create back link
					$child.prepend($('<li><a href="#" class="back">'+$(this).text()+'</a></li>'));
					
					//Make parent link behave like next
					if($(this).attr('href') === '#') {
						$(this).addClass('faux-link');
					}
				}

			//Attach behaviour for clicking parent element
			}).end().find('.parent > ' + settings.parentEl + ' > .next, .parent > .faux-link').click(function(e) {
			
				//Stop href from firing
				e.preventDefault();
			  
				//Get the next element to show
				var $elNext = $(this).parents('li').find('> ul');
				
				//Get siblings so we can adjust z-index
				$elNext.removeClass('hidden').end().siblings().find('> ul').addClass('hidden');
			  
				//Set nav height
				var $elNext = $(this).parent().parent().find('> ul');
				setHeight($elNext, $nav);

				//Shift nav
				shift($nav, $(this).parents('li').length, 0);
			
			//Attach behaviour for clicking back button
			}).end().find('a.back').not('.allow-default').click(function(e) {
			
				//Stop href from firing
				e.preventDefault();
			  
				//Get the next element to show
				var $elPrev = $(this).parents('ul').parents('ul');
			  
				//Set nav height
				setHeight($elPrev, $nav);
				
				//Shift nav
				shift($nav, $(this).parents('li').length, 2);
				
			});
			
			//If menuAim is available
			if($.fn.menuAim)
			{
				$nav.addClass('menuaim').find('ul').menuAim({
					activate: menuaimActivate,
					deactivate: menuaimDeactivate,
					exitMenu: menuaimExitMenu
				});
			}
			
		});
	
	};

}(jQuery));


// WEBPACK FOOTER //
// ./AppBundle/Resources/assets/js/umsom/silk/nav.js